import type { AppDispatch } from '/business/shared/state/store';

import setBasketMeta from '/business/shared/state/actions/basket/setBasketMeta';

import { basketMetaUpdateKeys } from '/business/shared/util/Statics';
import type { ElectricityHeatSteamLocationPayload } from '/business/shared/state/selectors/application/electricityHeatSteam/electHeatSteamTypes';

const normaliseOptionalNumber = (value: number | string | null | undefined) => {
  if (typeof value !== 'string') {
    return value;
  }
  const parsedValue = Number(value);
  return Number.isNaN(parsedValue) ? null : parsedValue;
};

const normaliseFloorSpaceUnit = (value: 'sqft' | 'm2' | null | undefined) => value ?? undefined;

const saveLocation =
  ({
    location,
    isDelete = false,
    applicationId,
  }: {
    location: ElectricityHeatSteamLocationPayload;
    isDelete?: boolean;
    applicationId: number | null;
  }) =>
  async (dispatch: AppDispatch) => {
    if (!applicationId) {
      throw new Error('Application Id is missing');
    }
    if (isDelete && !location.id) {
      throw new Error('id is missing for delete');
    }

    await dispatch(
      setBasketMeta({
        item: {
          key: basketMetaUpdateKeys.PACKAGE2_LOCATION,
          data: {
            location: {
              ...location,
              itemId: location.id,
              sharedMeterTotalBuildingFloorSpace: normaliseOptionalNumber(location.sharedMeterTotalBuildingFloorSpace),
              sharedMeterTotalBuildingFloorSpaceUnit: normaliseFloorSpaceUnit(
                location.sharedMeterTotalBuildingFloorSpaceUnit,
              ),
              sharedMeterBusinessOnlyFloorSpace: normaliseOptionalNumber(location.sharedMeterBusinessOnlyFloorSpace),
              sharedMeterBusinessOnlyFloorSpaceUnit: normaliseFloorSpaceUnit(
                location.sharedMeterBusinessOnlyFloorSpaceUnit,
              ),
            },
            isDelete,
          },
        },
        applicationId,
        isConfirmedByUser: false,
      }),
    );
  };

export default saveLocation;
